<h1 mat-dialog-title>Erreur</h1>
<div mat-dialog-content>
    <pre>{{ data | json}}</pre>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>OK</button>
</div>